import {
  GET_REPOSITORY_REQUEST,
  GET_FOLDER_REQUEST,
  EXPLORE_FOLDER_REQUEST,
  CREATE_FOLDER_REQUEST,
  GET_TARGET_FOLDERS_REQUEST,
  EXPLORE_TARGET_FOLDERS_REQUEST,
  GET_TARGET_FOLDER_REQUEST,
  CLONE_AUDIENCE_REQUEST,
  DELETE_ITEM_REQUEST,
  RENAME_ITEM_REQUEST,
  MOVE_ITEM_REQUEST,
  TOGGLE_ITEM_SELECTION_REQUEST,
  TOGGLE_ALL_ITEM_SELECTION_REQUEST,
  GET_AUDIENCE_REQUEST,
  CREATE_AUDIENCE_REQUEST,
  GET_QUERY_PREVIEW_REQUEST,
  SAVE_AUDIENCE_REQUEST,
  REQUIRE_MISSING_ITEM_REQUEST,
  REPOSITORY_LOAD_MORE_RESULTS_REQUEST,
  OPEN_SAVE_MODAL,
  ADD_APPLICATION_DROPPING_ENTITY_REQUEST,
  REMOVE_APPLICATION_DROPPING_ENTITY_REQUEST,
  REMOVE_ALL_APPLICATION_DROPPING_ENTITIES_REQUEST,
  ADD_AUDIENCE_TO_COMPARE_REQUEST,
  OPEN_COMPARE_AFTER_SAVE,
  SET_LOADING_STATUS,
  SET_ERROR,
  GET_ALL_FOLDERS_REQUEST,
  ADD_ITEM_TO_COMPARE,
  REMOVE_ITEM_TO_COMPARE,
  REMOVE_ALL_ITEMS_TO_COMPARE,
  RESET_COMPARE_ERROR,
  ADD_SELECTED_AUDIENCES,
  REMOVE_SELECTED_AUDIENCE,
  REMOVE_ALL_SELECTED_AUDIENCES,
} from '../constants/action-types';

export const requestRepository = (repoFilterType, q, pagination) => ({
  type: GET_REPOSITORY_REQUEST,
  repoFilterType,
  q,
  pagination,
});

export const requestTargetFolders = (q = undefined, pagination) => ({
  type: GET_TARGET_FOLDERS_REQUEST,
  q,
  pagination,
});

export const requestExploreTargetFolders = id => ({
  type: EXPLORE_TARGET_FOLDERS_REQUEST,
  id,
});

export const requestTargetFolder = id => ({
  type: GET_TARGET_FOLDER_REQUEST,
  id,
});

export const requestFolder = id => ({
  type: GET_FOLDER_REQUEST,
  id,
});

export const exploreFolder = id => ({
  type: EXPLORE_FOLDER_REQUEST,
  id,
});

export const requestUpdateNavigation = (path, filter) => ({
  type: EXPLORE_FOLDER_REQUEST,
  path,
  filter,
});

export const requestCreateFolder = (data, path, isSearch) => ({
  type: CREATE_FOLDER_REQUEST,
  data,
  path,
  isSearch,
});

export const requestCloneAudience = (id, data) => ({
  type: CLONE_AUDIENCE_REQUEST,
  id,
  data,
});

export const requestDeleteItems = (items, itemType) => ({
  type: DELETE_ITEM_REQUEST,
  items,
  itemType,
});

export const requestRenameItem = (id, newLabel) => ({
  type: RENAME_ITEM_REQUEST,
  id,
  newLabel,
});

export const requestMoveItem = (id, data, movingItem, destinationItem) => ({
  type: MOVE_ITEM_REQUEST,
  id,
  itemType: movingItem.type,
  movingItem,
  destinationItem,
  data,
});

export const toggleItemSelection = id => ({
  type: TOGGLE_ITEM_SELECTION_REQUEST,
  id,
});

export const toggleAllItemSelection = (mode, ids) => ({
  type: TOGGLE_ALL_ITEM_SELECTION_REQUEST,
  ids,
  mode,
});

export const requestAudienceDetails = id => ({
  type: GET_AUDIENCE_REQUEST,
  id,
});

export const requestCreateAudience = (queryData, app, silentMode) => ({
  type: CREATE_AUDIENCE_REQUEST,
  queryData,
  app,
  silentMode,
});

export const requestQueryPreview = selectedItem => ({
  type: GET_QUERY_PREVIEW_REQUEST,
  selectedItem,
});

export const openSaveModal = data => ({
  type: OPEN_SAVE_MODAL,
  data,
});

export const requestSaveAudience = (id, data) => ({
  type: SAVE_AUDIENCE_REQUEST,
  id,
  data,
});

export const requireMissingItemRequest = data => ({
  type: REQUIRE_MISSING_ITEM_REQUEST,
  data,
});

export const loadMoreRepository = filter => ({
  type: REPOSITORY_LOAD_MORE_RESULTS_REQUEST,
  filter,
});

export const addApplicationDroppingEntity = (audience, appName) => ({
  type: ADD_APPLICATION_DROPPING_ENTITY_REQUEST,
  audience,
  appName,
});

export const removeApplicationDroppingEntity = (audienceId, appName) => ({
  type: REMOVE_APPLICATION_DROPPING_ENTITY_REQUEST,
  audienceId,
  appName,
});

export const removeAllApplicationDroppingEntities = appName => ({
  type: REMOVE_ALL_APPLICATION_DROPPING_ENTITIES_REQUEST,
  appName,
});

export const addAudienceToCompare = queryData => ({
  type: ADD_AUDIENCE_TO_COMPARE_REQUEST,
  queryData,
});

export const openCompareAfterSave = audiences => ({
  type: OPEN_COMPARE_AFTER_SAVE,
  audiences,
});

export const setLoadingStatus = loading => ({
  type: SET_LOADING_STATUS,
  loading,
});

export const setError = message => ({
  type: SET_ERROR,
  message,
});

export const getAllFolders = () => ({
  type: GET_ALL_FOLDERS_REQUEST,
});

export const addSelectedAudiences = audiences => ({
  type: ADD_SELECTED_AUDIENCES,
  audiences,
});

export const removeSelectedAudience = audienceId => ({
  type: REMOVE_SELECTED_AUDIENCE,
  audienceId,
});

export const removeAllSelectedAudiences = () => ({
  type: REMOVE_ALL_SELECTED_AUDIENCES,
});

export const addItemToCompare = audience => ({
  type: ADD_ITEM_TO_COMPARE,
  audience,
});

export const removeItemToCompare = id => ({
  type: REMOVE_ITEM_TO_COMPARE,
  id,
});

export const removeAllItemsToCompare = () => ({
  type: REMOVE_ALL_ITEMS_TO_COMPARE,
});

export const resetCompareError = () => ({
  type: RESET_COMPARE_ERROR,
});
